import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.75 7a4.25 4.25 0 1 1 8.34 1.16q.776.011 1.505.17.154-.642.155-1.33a5.75 5.75 0 1 0-8.365 5.122q.361-.673.847-1.256A4.25 4.25 0 0 1 6.75 7m.799 7.8C4.158 15.918 1.66 18.644 1.66 22a.75.75 0 0 0 1.5 0c0-2.385 1.737-4.57 4.375-5.61a7.6 7.6 0 0 1 .014-1.59",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M15.497 17.96a1.8 1.8 0 1 0 0-3.599 1.8 1.8 0 0 0 0 3.598"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M9.5 16.688v-1.055c0-.624.51-1.14 1.14-1.14 1.085 0 1.529-.767.983-1.709a1.14 1.14 0 0 1 .42-1.553l1.037-.594a1 1 0 0 1 1.367.36l.067.114c.54.942 1.427.942 1.973 0l.066-.114a1 1 0 0 1 1.367-.36l1.037.594c.546.312.732 1.014.42 1.553-.546.942-.102 1.71.984 1.71.623 0 1.139.51 1.139 1.139v1.055c0 .624-.51 1.14-1.14 1.14-1.085 0-1.529.767-.983 1.709a1.137 1.137 0 0 1-.42 1.553l-1.037.594a1 1 0 0 1-1.368-.36l-.066-.114c-.54-.942-1.427-.942-1.973 0l-.066.114a1 1 0 0 1-1.367.36l-1.037-.594a1.14 1.14 0 0 1-.42-1.553c.546-.942.102-1.71-.984-1.71-.63 0-1.139-.515-1.139-1.139"
    }, null, -1)
  ]))]))
}
export default { render: render }